<template>
  <div class="draft-box">
    <div class="top">
      <Header ref="header" moduleTitle="预配舱单-上海">
        <template slot="searchBox">
          <DraftSearch ref="draftSearch" @fnSearch="searchList" @refreshSearch="refreshSearch" @exportExcel="exportExcel" />
        </template>
      </Header>
    </div>
    <div class="draft-content" v-if="!firstUseType">
      <div class="btn-div">
        <el-button type="primary" icon="iconfont icon-daorucangdan" @click="exportCps">导入舱单</el-button>
        <!-- <el-button type="primary" disabled>button</el-button> -->
        <!-- <el-button type="success">button</el-button> -->
        <el-button type="info" icon="iconfont icon-xinjiancangdan" @click="addCps">新建舱单</el-button>
        <el-button type="primary" icon="iconfont icon-fasong" :disabled="unSendDisabledType" @click="moveSent">移至待发送</el-button>
        <el-button type="primary" icon="el-icon-delete" :disabled="disabledType" @click="deleteMsg">删除</el-button>
      </div>
      <WTable :WTableOpts="WTableOpts" @selection-change="handleSelectionChange">
        <template #valid="{ row }">
          <el-popover trigger="hover" v-if="!row.valid">
            <div style="max-height: 300px; overflow-y: auto;">
              <div>您填写的数据有误，请检查后，重新编辑～</div>
            </div>
            <span slot="reference" style="color: #f56c6c; cursor: pointer;"><i class="iconfont icon-zhuangtai-cuowu w-red-1"></i></span>
          </el-popover>
          <el-popover trigger="hover" v-else>
            <div style="max-height: 300px; overflow-y: auto;">
              <div>校验结果正确，请移至待发送～</div>
            </div>
            <span slot="reference" style="color: #f56c6c; cursor: pointer;"><i class="iconfont icon-zhuangtai-zhengque w-green-1"></i></span>
          </el-popover>
        </template>
        <template #masterBillNo="{ row }">
          <div class="flex">
            <div class="table-content">{{ row.masterBillNo }}</div>
            <div class="content-center" v-if="row.masterBillNo" @click="copy(row.masterBillNo)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template>
        <template #houseBillNos="scoped">
          <div class="house-box" v-for="(item,idx) in scoped.row.houseBillNos" :key="idx" :style="idx > 0 ? 'border-top: 1px solid #EBEEF5;' : ''">
            <div class="flex">
              <div class="table-content">{{ item }}</div>
              <div class="content-center" v-if="item" @click="copy(item)"><i class="iconfont icon-fuzhi"></i></div>
            </div>
          </div>
        </template>
        <template #shipName="{ row }">
          <div class="flex">
            <div class="table-content max-200">{{ row.shipName }}</div>
            <div class="content-center" v-if="row.shipName" @click="copy(row.shipName)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template>
        <template #voyageNo="{ row }">
          <div class="flex">
            <div class="table-content max-200">{{ row.voyageNo }}</div>
            <div class="content-center" v-if="row.voyageNo" @click="copy(row.voyageNo)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template>

        <template #carrier="{ row }">
          <span>{{ row.carrier }}</span>
        </template>
        <template #shipAgent="{ row }">
          <span>{{ row.shipAgent }}</span>
        </template>
        <template #newOperator="{ row }">
          <span v-if="row.modifierUser && row.modifierUser.nickname">{{ row.modifierUser.nickname }}</span>
          <span v-else>{{ row.creatorUser ? row.creatorUser.nickname : '/' }}</span>
        </template>

        <template #operation="{ row }">
          <div class="table-btn-box">
            <el-link type="primary" :underline="false" @click="editCps(row)">编辑</el-link>
            <el-link type="primary" :underline="false" @click="copyCps(row)">复制</el-link>
          </div>
        </template>
      </WTable>
      <div class="pagination" v-if="total > 0">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" />
      </div>
    </div>

    <FirstEmpty v-else @exportCps="exportCps" @addCps="addCps" />
    <WUploadDialog ref="refWUploadDialog" title="导入舱单" product="CPS" :fileTemplate="fileTemplate" :action="action" :headers="headers" :on-success="handleSuccess" :on-error="handleError" :setupTxtArr="['第二步：根据提示信息完善表格内容', '第三步：上传已填写完整的模版']" />

  </div>
</template>

<script>
import Header from "@/components/cps2/Header"
import DraftSearch from "./search/DraftSearch.vue"
import FirstEmpty from '@/components/cps2/FirstEmpty'
import { httpAgent } from "@/api/ajax";


export default {
  name: "DraftBox",
  components: { 
    Header,
    DraftSearch,
    FirstEmpty,
  },
  props: {
    refreshDraft: {
      type: String,
      default: ''
    },
  },
  data(){
    return {
      headers:{
        token: localStorage.getItem('userToken'),
      },
      errorTxt: '', // 导入报错文案
      firstUseType: false, // 引导
      action: window.location.origin + '/agent/ccam/drafts/import',


      total: 0, // 总数 
      pageNum: 1, // 页码 
      pageSize: 10, // 条数
      chooseList: [], // 选中数据
      validList: [],
      searchData: {}, // 搜索数据

      fileTemplate: {
        name: '舱单导入模版.xlsx',
        url: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/cps_traveler/%E8%88%B1%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      },
      WTableOpts: {
        data: [], // 列表数据
        tableAttrs: { border: false },
        tableColAttrs: [
          { type: 'selection', fixed:"left" },
          { prop: '', label: '状态', slotName: 'valid' },
          { prop: '', label: '主提单号', slotName: 'masterBillNo', width: '320px' },
          { prop: '', label: '分提单号', slotName: 'houseBillNos', width: '320px' },
          { prop: '', label: '船名', slotName: 'shipName', width: '230px' },
          { prop: '', label: '航次', slotName: 'voyageNo', width: '230px' },
          { prop: '', label: '船公司', slotName: 'carrier', width: '150px' },
          { prop: '', label: '船代', slotName: 'shipAgent', width: '100px' },
          { prop: 'totalPackages', label: '总件数', width: '100px'  },
          { prop: 'totalGrossWeight', label: '总毛重', width: '100px'  },
          { prop: 'totalVolume', label: '总体积', width: '100px'  },
          { prop: '', label: '提交人', slotName: 'newOperator', width: '150px'},
          { prop: 'gmtModified', label: '编辑时间', 'min-width': '200px' },
          { prop: '', label: '操作', width: '150px', slotName: 'operation',fixed:"right"  }
        ]
      }
    }
  },
  computed: {
    // 删除 按钮状态
    disabledType(){
      return this.chooseList.length > 0 ? false : true
    },
    // 待发送 按钮状态
    unSendDisabledType(){
      return this.validList.every(o => o == true) && this.chooseList.length > 0 ? false : true
    },
  },
  watch: {
    refreshDraft(newName, oldName){
      console.log(newName)
      if(newName) {
        this.pageSize = 10
        this.pageNum = 1
        this.getList()
      }
    }
  },
  created(){
    this.firstUseCcam()
    this.getList()
    //导入舱单请求头信息补充
    let domain = '';
    if (window.location.host.split('.')[0] == 'www') {
      domain = window.location.host.split('.')[1];
    } else {
      domain = window.location.host.split('.')[0];
    }
    this.headers['X-company-domain'] = domain;
  },
  async mounted(){
    await this.$refs.draftSearch.firstClick()
    await this.$refs.draftSearch.fnSearch()
  },
  methods: {
    // 获取列表
    getList(){
      console.log(this.searchData)
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ...this.searchData,
        type: 'DRAFT'
      }
      httpAgent({
        url: `/agent/ccam/drafts`,
        method: "get",
        data:params
      }).then((res) => {
        this.WTableOpts.data = res.records
        this.total = res.total
        if(this.pageNum > 1 && res.records.length == 0){
          this.pageNum = this.pageNum -1
          this.getList()
        }
      })
    },
    firstUseCcam(){
      httpAgent({
        url: `/agent/ccam/drafts/firstUseCcam`,
        method: "get",
      }).then((res) => {
        this.firstUseType = res
      })
    },
    // 移至待发送
    moveSent(){
      httpAgent({
        url: `/agent/ccam/drafts/moveSent`,
        method: "post",
        data:this.chooseList
      }).then((res) => {
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.getList()
      })
    },
    // 删除
    deleteMsg(){
      this.$confirm('确定要删除当前数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        httpAgent({
          url: `/agent/ccam/drafts`,
          method: "delete",
          data:this.chooseList
        }).then((res) => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList()
        })
      })
    },
    // 重置
    refreshSearch(){
      this.searchData = {}
      this.$refs.draftSearch.refreshTime()
    },
    // 导出
    exportExcel(query){
      if(!query.gmtModifiedBegin && !query.gmtModifiedEnd){
        this.$message({
          message: '请选择时间',
          type: 'error'
        })
        return
      }
      query.token = this.headers.token;
      query['X-company-domain'] = this.headers['X-company-domain'];
      let keys = Object.keys(query);
      let arr = '';
      for(let i=0;i<keys.length;i++){
        if(query[keys[i]]){
          arr = arr + '&' + keys[i] + '=' + query[keys[i]]
        }
      }
      arr = arr.substring(1);
      let url = '/agent/ccam/export/draft?'+arr;
      console.log(url);
      window.open(url);
      // httpAgent({
      //   url: `/agent/ccam/export/draft`,
      //   method: "get",
      //   data: query,
      //   responseType: "blob"
      // }).then((res) => {
      //   download(res, `${'CPS导出数据'}.xlsx`)
      // })
    },
    // 点击查询
    searchList(query){
      this.searchData = query
      this.pageNum = 1
      this.pageSize = 10
      this.getList()
    },
    // 切换条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val
      this.getList()
    },
    // 切换页码
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val
      this.getList()
    },
    // 新建舱单
    addCps(){
      let data = {
        btn: 'ADD',
        btnName: '新增舱单',
        type: 'DRAFT',
        to: 'DETAIL',
        name: '草稿箱'
      }
      this.$router.push({
        name:"cpsDetail",
        query:data
      })
    },
    // 编辑舱单
    editCps({ id }){
      httpAgent({
        url: `/agent/ccam/drafts/${id}`,
        method: "get",
      }).then((res) => {
        let data = {
          btn: 'EDIT',
          btnName: '编辑舱单',
          type: 'DRAFT',
          to: 'DETAIL',
          name: '草稿箱',
          ...res,
          id: res.id
        }
        this.$router.push({
          name:"cpsDetail",
          query:data
        })
      })
    },
    // 复制舱单
    copyCps({ id }){
      httpAgent({
        url: `/agent/ccam/drafts/${id}`,
        method: "get",
      }).then((res) => {
        let response = { ...res }
        response.content.masterBillNo = ''
        let data = {
          btn: 'COPY',
          btnName: '复制舱单',
          type: 'DRAFT',
          to: 'DETAIL',
          name: '草稿箱',
          ...response,
        }
        this.$router.push({
          name:"cpsDetail",
          query:data
        })
      })
    },
    // 复制
    copy(e){
      this.$copyText(e)
			this.$message({
				type: 'success',
				message: '复制成功!'
			})
    },
    // 导入成功
    handleSuccess(response, file, fileList) {
      console.warn(response, file, fileList)
      this.$refs.refWUploadDialog.close()
      let data = {
        btn: 'EXPORT',
        btnName: '导入舱单',
        type: 'DRAFT',
        to: 'DETAIL',
        name: '草稿箱',
        ...response,
      }
      this.$router.push({
        name:"cpsDetail",
        query:data
      })
    },
    //导入失败
    handleError(err, file, fileList) {
      console.log(err.message)
      console.warn(err, file, fileList)
    },
    // 导入舱单
    async exportCps(){
      let flag = await this.$refs.refWUploadDialog.open()
      console.warn(flag)
    },
    // table 选择
    handleSelectionChange(e){
      console.log(e)
      this.chooseList = []
      this.validList = []
      this.chooseList = e.map(o => o.id)
      this.validList = e.map(o => o.valid)
      console.log(this.chooseList)
      console.log(this.validList)
      console.log(this.validList.every(o => o == true))
    }
  }
};
</script>

<style scoped lang="less">
.draft-box {
  font-size: 14px;
  color: #333333;
  display: flex;
  flex-direction: column;
  height: 100%;
  .draft-content {
    position: relative;
    background: #ffffff;
    border-radius: 4px;
    padding: 24px;
    height: 100%;
  }
  .btn-div {
    margin-bottom: 24px;
  }

  .house-box {
    height: 54px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .table-content {
    max-width: 290px;
    margin-right: 10px;
  }
  .max-200 {
    max-width: 200px;
  }

  .icon-fuzhi {
    color: #1170eb;
    font-size: 12px;
    cursor: pointer;
  }
  .icon-shuaxin {
    font-size: 14px;
    color: #000000;
    cursor: pointer;
  }
}
</style>
